import React, { useEffect, useState } from "react";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useAuth } from "../../../contexts/auth";
import TagService from "../../../services/TagService";
import "../ListTags/ListTags.css";
import { TagTypeText } from "../../../enums/tagTypes";
import { TagTypeIcons } from "../../../utils/tagTypeIcons";
import { useListManager } from "../../../contexts/list.manager";
import { FaCircleCheck } from "react-icons/fa6";

const ListClientTags = ({ showSelectedIcon = false, filters = {}, ...props }) => {
   const [tags, setTags] = useState([]);
   const [maxPage, setMaxPage] = useState(1);
   const { user } = useAuth();
   const { lineSelected } = useListManager();

   const getTags = async (clientID) => {
      const response =
         await TagService.listTagsByClientAndType(
            clientID,
            "PERSON"
         );
      setTags(
         response.data
            .filter(tag => filters.licensePerson ? tag.licensePerson : true)
      );
   };

   useEffect(() => {
      getTags(user.userData.selectedOrganizationId);
   }, [user, props.filters, props.refreshKey]);

   const preAdditionalColumns = showSelectedIcon ? [
      {
         collumnLabel: "",
         type: "custom",
         custom: ({ row }) => (
            <div className="relative size-[18px]!">
               <input
                  type="radio"
                  name={`unit-${row.id}`}
                  value={row.id}
                  checked={lineSelected?.id === row.id}
                  className="opacity-0 peer/unit"
               />
               <span className="absolute size-[calc(100%+6px)] peer-focus/unit:outline peer-focus/unit:outline-(--primaryColor) rounded-full peer-focus/unit:outline-2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></span>
               {lineSelected?.id === row.id ? (
                  <FaCircleCheck
                     size={18}
                     className="text-green-500 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                  />
               ) : (
                  <div className="size-full bg-transparent border! border-(--borderColor)! rounded-full inset-0 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></div>
               )}
            </div>
         ),
         customHeader: () => (<></>)
      }
   ] : [];

   return (
      <>
         <div className="list-container list-visibility">
            <List
               collumsObjIndex={[
                  ...preAdditionalColumns,
                  {
                     collumnLabel: "Nome",
                     index: "name",
                     type: "text",
                  },
                  { collumnLabel: "Ícone", index: "icon", type: "icon" },
               ]}
               listEntityName={"tags"}
               changeColumnValue={Object.entries(TagTypeText).map(
                  ([key, text]) => ({
                     old: key,
                     new: text,
                     chip: true,
                     // icon: React.createElement(TagTypeIcons[key], { size: 16 })
                  }),
               )}
               data={tags?.filter(tag => !props.search || tag.name?.toLowerCase().includes(props.search?.toLowerCase()))}
            />
         </div>
      </>
   );
};

export default ListClientTags;
